import { Card, Table, Tag, Space, Descriptions, Typography, message, Input, Button, Select } from 'antd';
import { useEffect, useState } from 'react';
import { CheckCircleOutlined, CloseCircleOutlined, DownloadOutlined } from '@ant-design/icons';
import { apiCall } from '../../API/RestApi';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { currencyFormat } from '../../Utils/formatCurrency';
import { modalError } from '../../Component/Modal/ModalLayout';
import { exportSalaryPdf } from './excel/ExportSalaryPdf';
const { Text } = Typography;
function Salary() {
    const token = useSelector((state) => state.user.token);
    const user = useSelector((state) => state.user.user);
    const [detailData, setDetailData] = useState();
    const [loading, setLoading] = useState(false);
    const [load, setLoad] = useState(0);
    const [year, setYear] = useState(new Date().getFullYear());
    const [month, setMonth] = useState(moment(new Date().getMonth() + 1, 'M').format('MMMM')); // bulan dari 1–12
    const [isAlert, setIsAlert] = useState(false);
    const [password, setPassword] = useState('');
    const [authorized, setAuthorized] = useState(false);
    const [companySetting, setCompanySetting] = useState({});

    useEffect(() => {
        getApi("GET", `/salary/employee?year=${year}&month=${month}`, 'all');
        getApi("GET", '/company-setting', 'company');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isAlert, load]);

    const getApi = (method, url, type, data = null) => {
        setLoading(true);

        const dataReq = {
            method: method,
            url: url,
            data: {
                data: data,
                headers: {
                    Authorization: 'Bearer ' + token
                }
            }
        };
        apiCall(dataReq).then((res) => {
            if (res.status === "success") {
                switch (type) {
                    case 'all':
                        setDetailData(res.data);
                        setLoading(false);
                        break;

                    case 'company':
                        setCompanySetting(res.data || {});
                        setLoading(false);
                        break;

                    case 'password':
                        setAuthorized(true);
                        setLoading(false);
                        break;

                    default:
                        setLoading(false);
                        break;
                }
            } else {
                if (type === 'password') {
                    modalError(res.message)
                }
                setLoading(false);
            }
        }).catch((e) => {
            setLoading(false);
        })
    }

    const handlePasswordSubmit = () => {
        getApi("POST", `/auth/password`, 'password', { password: password });
    }

    const currentYear = new Date().getFullYear();
    const years = Array.from({ length: 5 }, (_, i) => currentYear - i);
    const months = moment.months().map((m, i) => ({ label: m, value: i + 1 }));

    return (
        <div>
            {
                !authorized ? (
                    <Card title="Masukkan Password" style={{ maxWidth: 400 }}>
                        <Input.Password
                            placeholder="Password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            onPressEnter={handlePasswordSubmit}
                        />
                        <Button type="primary" onClick={handlePasswordSubmit} style={{ marginTop: 10 }}>
                            Submit
                        </Button>
                    </Card>
                ) : (
                    detailData && (
                        <Space direction="vertical" style={{ width: '100%' }} size="large">
                            <Card size="small" title="Filter Gaji Bulanan" bordered={false}>
                                <Space>
                                    <Button
                                        type="default"
                                        onClick={() => exportSalaryPdf(detailData, companySetting)}
                                        icon={<DownloadOutlined />}
                                    >
                                        Export PDF
                                    </Button>


                                    <Select
                                        placeholder="Pilih Tahun"
                                        style={{ width: 120 }}
                                        onChange={(value) => setYear(value)}
                                        value={year}
                                    >
                                        {years.map((y) => (
                                            <Select.Option key={y} value={y}>{y}</Select.Option>
                                        ))}
                                    </Select>
                                    <Select
                                        placeholder="Pilih Bulan"
                                        style={{ width: 150 }}
                                        onChange={(value) => setMonth(value)}
                                        value={month}
                                    >
                                        {months.map((m) => (
                                            <Select.Option key={m.value} value={m.label}>{m.label}</Select.Option>
                                        ))}
                                    </Select>
                                    <Button type="primary" onClick={() => {
                                        setLoading(true);
                                        setLoad(load + 1);
                                    }} >
                                        Cari
                                    </Button>
                                </Space>
                            </Card>
                            {/* Section 1: Informasi Gaji Umum */}
                            <Card size="small" title="Informasi Umum" bordered={false}>
                                <Descriptions column={2} size="small">
                                    <Descriptions.Item label="Judul">{detailData.title}</Descriptions.Item>
                                    <Descriptions.Item label="Gaji Net">
                                        {currencyFormat(detailData.net_salary)}
                                    </Descriptions.Item>
                                    <Descriptions.Item label="Bulan / Tahun">{detailData.month} / {detailData.year}</Descriptions.Item>
                                    <Descriptions.Item label="Status">
                                        <Tag
                                            icon={
                                                detailData.status ? (
                                                    <CheckCircleOutlined />
                                                ) : (
                                                    <CloseCircleOutlined />
                                                )
                                            }
                                            color={detailData.status ? 'green' : 'red'}
                                        >
                                            {detailData.status ? 'Aktif' : 'Tidak Aktif'}
                                        </Tag>
                                    </Descriptions.Item>
                                    <Descriptions.Item label="Dibuat Pada">
                                        {moment(detailData.created_at).format('YYYY-MM-DD HH:mm:ss')}
                                    </Descriptions.Item>
                                    <Descriptions.Item label="Diubah Pada">
                                        {moment(detailData.updated_at).format('YYYY-MM-DD HH:mm:ss')}
                                    </Descriptions.Item>
                                </Descriptions>
                            </Card>

                            {/* Section 2: Tabel Komponen Gaji */}
                            {detailData.pay_details?.length > 0 && (
                                <Card
                                    size="small"
                                    title="Rincian Komponen Gaji"
                                    bordered={false}
                                    style={{ marginTop: 10 }}
                                >
                                    <Table
                                        style={{ width: '100%' }}
                                        size="small"
                                        bordered
                                        columns={[
                                            {
                                                title: 'Nama',
                                                key: 'name',
                                                render: (_, record) => <Text>{record.pay_title?.slip_name || record.pay_title?.name || '-'}</Text>,
                                            },
                                            {
                                                title: 'Jumlah',
                                                dataIndex: 'allowance',
                                                align: 'right',
                                                key: 'allowance',
                                                render: (value) => (
                                                    <Text style={{ fontWeight: 500 }}>
                                                        {currencyFormat(value)}
                                                    </Text>
                                                ),
                                            },
                                        ]}
                                        dataSource={detailData.pay_details.filter(item => item.pay_title.name !== "Gaji dibayarkan")}
                                        pagination={false}
                                        rowKey="id"
                                    />
                                </Card>
                            )}
                        </Space>
                    )
                )
            }
        </div>
    );
}

export default Salary;
